import EUSPA from "../img/EUSPA_logo.png";
import Copernicus from "../img/Copernicus_logo.png";
import EEA from "../img/EEA_logo.png";
import ECMWF from "../img/ECMWF_logo.png";
import JRC from "../img/JRC_logo.png";
import ESA from "../img/ESA_logo.png";
import SatCen from "../img/SatCen_logo.png";
import Mercator from "../img/Mercator_logo.png";

const About = (props) => {

  const formatAttribution = (attribution) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(attribution, "text/html");

    const convertNode = (node, key) => {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent;
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "A") {
        return (
          <a className="ccl-link_color" key={key} href={node.href} target="_blank" rel="noopener noreferrer">
            {node.textContent}
          </a>
        );
      }
      return node.textContent;
    };

    return Array.from(doc.body.childNodes).map((node, i) => convertNode(node, i));
  };

  return (
    <div className="help-container">
      <p>
        The World Heritage Hub provides access to Copernicus information relevant to cultural and natural heritage. It has been developed by the European Union Agency for the Space Programme (EUSPA) under the Copernicus Programme.
      </p>
      <div className="help-logos">
        <div className="help-logos-one">
          <a className="ccl-link_color" href="https://www.copernicus.eu/" target="_blank" rel="noopener noreferrer">
            <img src={Copernicus} alt="Copernicus"/>
          </a>
        </div>
        <p>Implemented by:</p>
        <div className="help-logos-one">
          <a className="ccl-link_color" href="https://www.euspa.europa.eu/" target="_blank" rel="noopener noreferrer">
            <img src={EUSPA} alt="European Union Agency for the Space Programme"/>
          </a>
        </div>
        <p>In collaboration with:</p>
        <div className="help-logos-three">
          <a className="ccl-link_color" href="https://www.eea.europa.eu/" target="_blank" rel="noopener noreferrer">
            <img src={EEA} alt="European Environment Agency"/>
          </a>
          <a className="ccl-link_color" href="https://www.ecmwf.int/" target="_blank" rel="noopener noreferrer">
            <img src={ECMWF} alt="European Centre for Medium-Range Weather Forecasts"/>
          </a>
          <a className="ccl-link_color" href="https://joint-research-centre.ec.europa.eu/" target="_blank" rel="noopener noreferrer">
            <img src={JRC} alt="Joint Research Centre"/>
          </a>
        </div>
        <div className="help-logos-three">
          <a className="ccl-link_color" href="https://www.esa.int/" target="_blank" rel="noopener noreferrer">
            <img src={ESA} alt="European Space Agency"/>
          </a>
          <a className="ccl-link_color" href="https://www.satcen.europa.eu/" target="_blank" rel="noopener noreferrer">
            <img src={SatCen} alt="European Union Satellite Centre"/>
          </a>
          <a className="ccl-link_color" href="https://www.mercator-ocean.eu/" target="_blank" rel="noopener noreferrer">
            <img src={Mercator} alt="Mercator Ocean International"/>
          </a>
        </div>
      </div>
      <p>
        WEkEO is the EU Copernicus DIAS reference service for environmental data, virtual processing environments, and skilled user support. Launched by the European Commission in 2018 and Jointly developed by leading Copernicus institutions, WEkEO platform provides seamless, unified access to Copernicus data, advanced processing resources and tools, and relevant additional datasets.
      </p>
      <hr/>
      <div className="help-attribution">
        <p>Powered by <a href="https://leafletjs.com" target="_blank" rel="noopener noreferrer" className="ccl-link_color">Leaflet</a>.</p>
        <p>Attribution: {formatAttribution(props.attribution)}</p>
      </div>
    </div>
  );
}

export default About;
